import styled from '@emotion/styled';

const Label = styled.span`
	display: block;
	font-weight: 500;
	line-height: 20px;
	padding: 10px 10px 10px 0;

	${props => props.theme.label || ''}
`;

export default Label;
